import Vue from "vue";
import "vue-class-component/hooks";
import VueWait from "vue-wait";
import { vueAppInsights } from "@/plugins";
import { router } from "@/router";
import "@/router/registerHooks";
import { store } from "@/store";
import App from "./App.vue";
import "./plugins/notifications";
import vuetify from "./plugins/vuetify";
import "./plugins/vee-validate";
import "./filters";
import VueMoment from "vue-moment";
import moment from "moment";

Vue.config.productionTip = false;
Vue.config.performance = process.env.NODE_ENV !== "production";

// Setup App Insights
vueAppInsights();

Vue.use(VueWait);
Vue.use(VueMoment, {
    moment,
});

new Vue({
    router,
    store,
    wait: new VueWait({ useVuex: true }),
    vuetify,
    render: h => h(App),
}).$mount("#app");
